import { ServiceAlertApiClient } from '@/libs/ServiceAlertApiClient';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as Common from '@/libs/Common';
import { useClientStore } from '@/stores/modules/clientInfo';

/**
 * @todo 登入檢查(for 9分鐘逾時提醒第10分鐘後登出)
 * @param refreshResult 是否強制刷新結果
 * @param handleError 是否自動處理錯誤
 * @returns 是否登入
 */
const ServiceAlertLoginCheck = async (refreshResult: boolean = false, handleError: boolean = true): Promise<boolean> => {
    Common.ConsoleLog('[ServiceAlert.LoginCheck] Api Start');
    const store = useClientStore();
    Common.ConsoleLog('[ServiceAlert.LoginCheck] Api : routeInitState = ' + store.routeInitState);

    if (store.routeInitState == false || refreshResult === true) {
        const url = RouteUrlList.API_CheckIfLogin.path;
        const config = {
            params: {
                showOverlay: ApiClient.paramTypeEnum.false,
                getServiceAlert: ApiClient.paramTypeEnum.false
            }
        };

        // 模擬延遲，例如 2000 毫秒（2 秒）
        // await delay(2000);

        try {
            const res: AxiosResponse<GeneralResp> = await ServiceAlertApiClient.post(url, {}, config);
            Common.ConsoleLog('[ServiceAlert.LoginCheck] Api isLogin call Api res :' + res.data.status);
            store.setLoginState(res.data.status);
            return res.data.status;
        } catch (e) {
            if (handleError) {
                ApiClient.HandleError(e);
            }
            return false;
        }
    } else {
        Common.ConsoleLog('[ServiceAlert.LoginCheck] Api isLogin from store :' + store.isLogin.valueOf());
        return store.isLogin.valueOf();
    }
};
export default ServiceAlertLoginCheck;
